import '../AboutProductionPage/AboutProductionPage.css';
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import aboutProductionAboutFirstImage from "../../assets/images/aboutProductionAboutFirstImage.webp";
import aboutProductionAboutSecondImage from "../../assets/images/aboutProductionAboutSecondImage.webp";
import aboutProductionAboutThirdImage from "../../assets/images/aboutProductionAboutThirdImage.webp";
import aboutProductionAboutFourthImage from "../../assets/images/aboutProductionAboutFourthImage.webp";
import aboutProductionAboutFifghtImage from "../../assets/images/aboutProductionAboutFifghtImage.webp";
import abouteCertificate1 from "../../assets/images/aboutCertificates/ISO 14001 новий.webp";
import abouteCertificate2 from "../../assets/images/aboutCertificates/ISO 27001 новий.webp";
import abouteCertificate3 from "../../assets/images/aboutCertificates/ISO 37001 новий.webp";
import abouteCertificate4 from "../../assets/images/aboutCertificates/Сертифікат ISO 22000.webp";
import abouteCertificate5 from "../../assets/images/aboutCertificates/Сертифікат ISO 28000.webp";
import abouteCertificate6 from "../../assets/images/aboutCertificates/Сертифікат ISO 45001_Страница_1.webp";
import abouteCertificate7 from "../../assets/images/aboutCertificates/Сертифікат ISO 45001_Страница_2.webp";
import abouteCertificate8 from "../../assets/images/aboutCertificates/Сертифікат ISO 9001.webp";

const certificates = [
    abouteCertificate1,
    abouteCertificate2,
    abouteCertificate3,
    abouteCertificate4,
    abouteCertificate5,
    abouteCertificate6,
    abouteCertificate7,
    abouteCertificate8,
]

const AboutProductionPageRu = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  return (
    <div className="page">
       <title>ООО «Николаевмолпром» — современное производство молочной продукции Pastoral</title>
       <meta name="description" content={"ООО «Николаевмолпром» — производитель натуральной молочной продукции под ТМ «Pastoral» и «Мумуля». Современное оборудование, европейские технологии, контроль качества и международные сертификаты ISO."}/>
    <Cover text={"“Pastoral” -  Французские традиции"} src={coverImageToUse} />
    <section className="about__production-about">
      <div className="about__production-about-first">
        <div className="about__production-about-first-texts">
          <h1 className="about__production-about-first-title mont-m">
          ООО Николаевмолпром
          </h1>
          <p className="about__production-about-first-text int-r-21">
          ООО «Николаевмолпром» было основано в 2001 году. На базе предприятия проведена реконструкция и организован выпуск молочной продукции под торговой маркой «Pastoral».
          </p>
          <p className="about__production-about-first-text int-r-21">
          Продукция ООО "Николаевмолпром" – это прежде всего качество, за которое мы отвечаем. Для организации производства высококачественной продукции в комплексе была проведена большая реконструкция.
          </p>
          <p className="about__production-about-first-text int-r-21">
          Имя бренда «Pastoral» вдохновлено французской молочной культурой.          </p>
          <p className="about__production-about-first-text int-r-21">
          В целях расширения дистрибуции в 2016 году мы создали Торговый дом «Домановский маслосырзавод».
          </p>
          <p className="about__production-about-first-text int-r-21">
          В 2025 году запущена демократическая и народная марка Мумуля и начат монтаж нового оборудования для запуска новинок.
          </p>
        </div>
        <img
          src={aboutProductionAboutFirstImage}
          alt="ТОВ Миколаївмолпром"
          className="about__production-about-first-image"
        />
      </div>
      <div className="about__production-about-second">
        <img
          src={aboutProductionAboutSecondImage}
          alt="Виробництво Миколаївмолпром"
          className="about__production-about-second-image"
        />
        <div className="about__production-about-second-cards">
          <div className="about__production-about-second-card">
            <h2 className="about__production-about-second-card-title mont-m">
            Естественность
            </h2>
            <p className="about__production-about-second-card-text int-r-21">
            Мы используем исключительно натуральное молоко и ингредиенты. Наши продукты сохраняют естественный вкус и пользу молока.
            </p>
          </div>
          <div className="about__production-about-second-card">
            <h2 className="about__production-about-second-card-title mont-m">
            Инновации
            </h2>
            <p className="about__production-about-second-card-text int-r-21">
            Мы постоянно совершенствуем рецептуры, технологические процессы, оборудование, ориентируемся на современные пищевые тренды.
            </p>
          </div>
          <div className="about__production-about-second-card">
            <h2 className="about__production-about-second-card-title mont-m">
            Польза
            </h2>
            <p className="about__production-about-second-card-text int-r-21">
            Мы создаем молочную продукцию, чтобы каждый получал сбалансированные полезные вещества, поддерживал здоровье и был полон энергии.
            </p>
          </div>
          <div className="about__production-about-second-card">
            <h2 className="about__production-about-second-card-title mont-m">
            Ответственность
            </h2>
            <p className="about__production-about-second-card-text int-r-21">
            Мы ответственно относимся к безопасности продуктов и производства, но наибольшую ответственность мы несем за здоровье потребителей.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section className="about__production-production-section">
      <h2 className="about__production-production-section-title mont-m">
      Производство
      </h2>
      <div className="about__production-production-wrapper">
          <div className="about__production-production-texts">
          <h3 className="about__production-production-subtitle mont-m">Поставка и проверка молока:</h3>
      <p className="about__production-production-text int-r-21">
      Все молоко, из которого производится продукция Доманевского маслосырзавода, закупается у проверенных фермерских хозяйств Украины и поступает на завод в специальных машинах-молоковозах. 
      </p>
      <p className="about__production-production-text int-r-21">
      Каждая партия молока проходит входной контроль в заводской лаборатории. Чтобы гарантировать высокое качество молочной продукции, мы установили и соблюдаем внутренние требования к качеству, которые являются более строгими, чем рекомендованные государственными нормативными документами.
      </p>
          </div>
          <img
              src={aboutProductionAboutThirdImage}
              alt="Виробництво Миколаївмолпром"
              className="about__production-production-image"
          />
      </div>
      <div className="about__production-production-wrapper reversed">
          <div className="about__production-production-texts">
          <h3 className="about__production-production-subtitle mont-m">Изготовление продукции:</h3>
      <p className="about__production-production-text int-r-21">
      Вся цельномолочная продукция — от молока до масла — изготавливается из натурального молока. Кисломолочные продукты мы создаем на основе европейских заквасок, а ряженка приобретает бархатистый вкус благодаря брожению. 
      </p>
      <p className="about__production-production-text int-r-21">
      Сыры готовим традиционно: с соблюдением всех этапов — засолки, созревания, плавления. Масло производим из 100% натуральных сливок методом взбивания.
      </p>
          </div>
          <img
              src={aboutProductionAboutFourthImage}
              alt="Виробництво Миколаївмолпром"
              className="about__production-production-image two"
          />
      </div>
      <div className="about__production-production-wrapper">
          <div className="about__production-production-texts">
          <h3 className="about__production-production-subtitle mont-m">Анализ готовой продукции:</h3>
      <p className="about__production-production-text int-r-21">
      Контроль качества готовой продукции  ТМ «Pastoral» осуществляется в соответствии с регламентами украинского законодательства, государственными требованиями и международными стандартами ISO 22000:2007. На каждую производственную партию выписывается сертификат качества, подкрепленный данными микробиологического контроля, контрольными органолептическими дегустациями.
      </p>
          </div>
          <img
              src={aboutProductionAboutFifghtImage}
              alt="Виробництво Миколаївмолпром"
              className="about__production-production-image three"
          />
      </div>
    </section>
    <section className="about__production-certificates">
      <h2 className="about__production-certificates-title mont-m">
      Сертификаты
      </h2>
     <div className="about__production-certificates-wrapper">
      {certificates.map((cert, idx) => (
          <img
              key={idx}
              src={cert}
              alt={`Сертифікат ${idx + 1}`}
              className="about__production-certificates-image"
          />
      ))}
     </div>
    </section>
  </div>  )
}

export default AboutProductionPageRu